// Client-side drift computation per handoff § engineering-answers Q2:
// "Server writes planned_end at activation; client computes drift
//  on every render."
//
// drift === true when
//   status not in ('complete', 'submitted_for_evaluation') &&
//   today > planned_end
//
// No severity tiers (handoff "nudge, not shame").

import type {
  ActivityPlannedDates,
  ActivityStateEntry,
  FrameworkInstance,
} from '@gc-coach/shared';

export function isActivityDrifting(
  state: ActivityStateEntry,
  planned: ActivityPlannedDates | undefined,
  todayIso: string,
): boolean {
  if (!planned) return false;
  if (state.state === 'complete') return false;
  return todayIso > planned.planned_end;
}

export function driftingActivities(instance: FrameworkInstance, todayIso: string) {
  const plannedById = new Map(instance.activity_planned_dates.map((p) => [p.activity_id, p]));
  return instance.activity_states.filter((s) =>
    isActivityDrifting(s, plannedById.get(s.activity_id), todayIso),
  );
}

export function todayIsoUtc(): string {
  const d = new Date();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
